//main
import ContentFormatXC from "../content/webc/content-format-xc";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import EventsListModule from "../content/events/events-list";

import { UserForm } from "../services/srvc-utilities";

export default function Events() {

  return (
  <>
    <ContentFormatXC 
      head='Events'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <EventsListModule />

        </>
      } 
    />
  </>
  )
}